import api from '@/services/api';

export const checkIsInternal = async (): Promise<boolean> => await api.get('/feature/internal');
